export function shouldRetryPlaybackInfoRequest(
  failureCount: number,
  error: unknown,
) {
  if (failureCount >= 2) return false;
  const status = typeof error === "object" && error !== null && "status" in error
    ? Number((error as { status?: unknown }).status)
    : undefined;
  if (!Number.isFinite(status)) return true;
  return status === 408 || status === 429 || status! >= 500;
}

export function getPlaybackInfoRetryDelay(attemptIndex: number) {
  return Math.min(2_500, 750 * (2 ** Math.max(0, attemptIndex)));
}
